module.exports = __webpack_public_path__ + "img/banano-bet-light-wallpaper.4a7d4ccb0c29035c5878163da58d15d5.png";